import { useTranslation } from 'react-i18next';
import { Heart, Church, MapPin, Utensils, PartyPopper } from 'lucide-react';

const Timeline = () => {
  const { t } = useTranslation();

  const timelineEvents = [
    { 
      time: '18:45', 
      icon: Heart, 
      title: t('arrival'), 
      description: t('arrivalDesc'),
      directionsUrl: 'https://maps.app.goo.gl/eSyPDs9rmHcPxWan6' 
    },
    { time: '19:00', icon: Church, title: t('cocktail'), description: t('cocktailDesc') },
    { 
      time: '20:00', 
      icon: MapPin, 
      title: t('dinner'), 
      description: t('dinnerDesc'),
      directionsUrl: 'https://maps.app.goo.gl/vkwWTVEzvsZrJnp96'
    },
    { time: '20:30', icon: Utensils, title: t('party'), description: t('partyDesc') },
    { time: '23:00', icon: PartyPopper, title: t('memories'), description: t('memoriesDesc') },
  ];

  return (
    <section id="timeline" className="py-20 bg-gradient-to-b from-stone-100 to-amber-50">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <h2 className="text-2xl md:text-5xl font-bold text-center mb-4 text-gray-800 px-2 md:px-4 break-words hyphens-auto">
          {t('timeline')}
        </h2>
        <p className="text-center text-gray-600 mb-16 max-w-2xl mx-auto px-4">
          {t('timelineSubtitle')}
        </p>

        <div className="relative">
          {/* Timeline line */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-gray-200 to-lime-700"></div>

          {timelineEvents.map((event, index) => {
            const Icon = event.icon;
            const isEven = index % 2 === 0;

            return (
              <div key={index} className={`relative mb-12 md:mb-16 flex items-center ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                {/* Content */}
                <div className={`w-full md:w-5/12 ${isEven ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  <div className="bg-white rounded-xl shadow-lg p-6 transform hover:scale-105 transition-transform duration-200">
                    <div className={`flex items-center gap-3 mb-3 ${isEven ? 'md:justify-end' : 'md:justify-start'}`}>
                      <div className="bg-amber-50 p-2 rounded-lg">
                        <Icon className="w-6 h-6 text-amber-800" />
                      </div>
                      <span className="text-2xl font-bold text-amber-800">{event.time}</span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{event.title}</h3>
                    <p className="text-gray-600 mb-3">{event.description}</p>
                    {event.directionsUrl && (
                      <a
                        href={event.directionsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-amber-800 hover:text-amber-900 font-semibold text-sm transition-colors"
                      >
                        <MapPin className="w-4 h-4" />
                        {t('getDirections') || 'Get Directions'}
                      </a>
                    )}
                  </div>
                </div>

                {/* Center dot */}
                <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-6 h-6 bg-white border-4 border-gray-600 rounded-full z-10"></div>

                {/* Spacer */}
                <div className="hidden md:block w-5/12"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Timeline;